import React,{useEffect, useState,useContext} from 'react';
import { FaUsers, FaUserTie, FaChartLine, FaCoins, FaUserPlus, FaAddressCard,FaWhatsapp, FaUserCheck, FaQuoteRight  } from 'react-icons/fa';

import { useNavigate } from 'react-router-dom';
import AddClient from '../components/AddClient';
import axios from 'axios';
import { set } from 'mongoose';
import { LoginContext } from '../contexts/logincontext';


const AdminDashboard = () => {

    const navigate = useNavigate();

    const {loggedInUser,changeLoggedInUser} = useContext(LoginContext);

    const [clientCount,setClientCount] = useState(0);
    const [trainerCount,setTrainerCount] = useState(0);
    const [ptclients,setPTClients] = useState(0);
    const [missingCount,setMissingCount] = useState(0);
    const [activeClientCount,setActiveClientCount] = useState(0);

    const fetchCount = async () => {
      try {
          const response = await axios.get('https://klimkaara-backend-pgnq.onrender.com/admins/getCount');
          if(response.status === 200) {
              setClientCount(response.data.clientCount);
              setTrainerCount(response.data.trainerCount);
              setPTClients(response.data.ptClients);
              setMissingCount(response.data.missingCount);
          }
      } catch (error) {
          console.error(error.response.data);
      }
    }

    const fetchActiveClientCount = async () => {
      try {
          const response = await axios.get('https://klimkaara-backend-pgnq.onrender.com/admins/getactiveclients');
          if(response.status === 200) {
              setActiveClientCount(response.data.totalClients);
          }
      } catch (error) {
          console.error(error.response?.data || error.message);
      }
    }

    useEffect(() => {
      fetchCount();
      fetchActiveClientCount();
    },[])



  return (
    <div className="min-h-screen bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        {loggedInUser && <div>
          <h2 className="text-2xl font-bold mb-4">Welcome, {loggedInUser.name}!</h2></div>}
        <h2 className="text-4xl font-bold text-center mb-10">Admin Dashboard</h2>
        
        {/* Dashboard Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* List of Clients */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col items-center justify-between text-center" onClick={() => navigate('/allclients')}>
            <FaUsers className="text-[#fded22] text-4xl mb-4" />
            <h3 className="text-2xl font-bold mb-2">List of Clients</h3>
            <p className="text-gray-400">Total: {clientCount}</p>
            <button className="mt-4 bg-[#fded22] text-black px-4 py-2 rounded-full font-semibold hover:bg-white transition">
              View All
            </button>
          </div>

          {/* Active Clients */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col items-center justify-between text-center" onClick={() => navigate('/activeclients')}>
            <FaUserCheck className="text-[#fded22] text-4xl mb-4" />
            <h3 className="text-2xl font-bold mb-2">Active Clients</h3>
            <p className="text-gray-400">Total: {activeClientCount}</p>
            <button className="mt-4 bg-[#fded22] text-black px-4 py-2 rounded-full font-semibold hover:bg-white transition">
              View Active
            </button>
          </div>

          {/* List of Personal Training Clients */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col items-center justify-between text-center"  onClick={() => navigate('/ptclients')}>
            <FaUserTie className="text-[#fded22] text-4xl mb-4" />
            <h3 className="text-2xl font-bold mb-2">Personal Training Clients</h3>
            <p className="text-gray-400">Total: {ptclients}</p>
            <button className="mt-4 bg-[#fded22] text-black px-4 py-2 rounded-full font-semibold hover:bg-white transition">
              View Details
            </button>
          </div>

          {/* List of Trainers */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col items-center justify-between text-center" onClick={() => navigate('/trainers')}>
            <FaUserTie className="text-[#fded22] text-4xl mb-4" />
            <h3 className="text-2xl font-bold mb-2">List of Trainers</h3>
            <p className="text-gray-400">Total: {trainerCount}</p>
            <button className="mt-4 bg-[#fded22] text-black px-4 py-2 rounded-full font-semibold hover:bg-white transition">
              Manage Trainers
            </button>
          </div>

          {/* Daily WhatsApp Message */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col items-center justify-between text-center" onClick={() => navigate('/daily-message')}>
            <div className="relative">
              <FaWhatsapp className="text-[#25D366] text-4xl mb-4" />
              <FaQuoteRight className="text-[#fded22] text-xl absolute -right-2 -top-2" />
            </div>
            <h3 className="text-2xl font-bold mb-2">Daily Motivation</h3>
            <p className="text-gray-400">Generate & Share</p>
            <button className="mt-4 bg-[#fded22] text-black px-4 py-2 rounded-full font-semibold hover:bg-white transition">
              Create Message
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
